// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_notFound__TOQ2U","statusCode":"notFound_statusCode__2C2Bw","text":"notFound_text__g6LaO"};